var map = {
	"./Billing_a.png": "dc01",
	"./Billing_d.png": "2374",
	"./MySettings_a.png": "dfcc",
	"./MySettings_d.png": "5f6a",
	"./OrderImport_a.png": "5b50",
	"./OrderImport_d.png": "24f5",
	"./Shipments_a.png": "97f3",
	"./Shipments_d.png": "4568"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32fa";